import React from "react";
import {Navigate} from "react-router-dom";
import {clearCurrentUser} from "../util/AuthUtil";
import {useAccount} from "../hooks/useAccount";

export default function AuthProtector({children}) {

  const mfeToken = localStorage.getItem("MFE_TOKEN");
  const [isReady] = useAccount(!!mfeToken);

  if (!mfeToken) {
    clearCurrentUser();
    return <Navigate to="/sign-in"/>;
  }

  if (!isReady) {
    return null;
  }

  return children;
}
